import script from "./SchoolSchedule.vue?vue&type=script&setup=true&lang=js"
export * from "./SchoolSchedule.vue?vue&type=script&setup=true&lang=js"

import "./SchoolSchedule.vue?vue&type=style&index=0&id=af07b830&lang=css"

const __exports__ = script;

export default __exports__